import React, { Component } from 'react'
import { bool, func } from 'prop-types'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { withTranslation, Trans } from 'react-i18next'
import { userType } from 'models/propTypes'
import { isPassword, isEmail } from 'utils/validate'

import { getLoginStatusMessage, getSignupStatusMessage } from 'utils/login'
import { Input } from 'components/FormElements'
import ActionButton from 'components/uiElements/ActionButton'

require('./SignupForm.scss')

class SignupForm extends Component {
    constructor(props) {
        super(props)
        this.onChange = this.onChange.bind(this)
        this.submit = this.submit.bind(this)
        this.validateForm = this.validateForm.bind(this)

        this.state = {
            email: '',
            password: '',
            passwordConfirm: '',
        }
    }

    onChange(e) {
        let val = e.target.value
        if (e.target.name === 'email') {
            val = val.trim()
        }
        this.setState({ [e.target.name]: val })
    }

    submit(e) {
        e.preventDefault()

        const { email, password } = this.state
        const userData = {
            email,
            password,
        }
        // TODO: move this check to the container
        if (this.props.isLogin) {
            this.props.loginWithEmail(userData)
        } else {
            this.props.signupWithEmail(userData)
        }
    }

    validateForm() {
        const s = this.state
        const { isLogin } = this.props
        return (
            isEmail(s.email) &&
            ((isLogin && s.password) || isPassword(s.password)) &&
            (isLogin || s.password === s.passwordConfirm)
        )
    }

    render() {
        const { isLogin, currentUser, t } = this.props
        const { email, password, passwordConfirm } = this.state

        return (
            <form className="SignupForm" method="POST" onSubmit={this.submit}>
                <Input
                    type="text"
                    placeholder={t('common.email')}
                    value={email}
                    onChange={this.onChange}
                    className={classNames({ error: email && !isEmail(email) })}
                    name="email"
                />
                <Input
                    type="password"
                    placeholder={t('login.password')}
                    value={password}
                    onChange={this.onChange}
                    name="password"
                />
                {isLogin ? null : (
                    <Input
                        type="password"
                        placeholder={t('login.confirm password')}
                        value={passwordConfirm}
                        onChange={this.onChange}
                        name="passwordConfirm"
                        className={classNames({ error: password && password !== passwordConfirm })}
                    />
                )}
                {isLogin ? (
                    <Link to="/recover" className="forgot">
                        {t('login.forgot password')}
                    </Link>
                ) : null}
                {currentUser.signupLoginStatus ? (
                    <p className={classNames('slMessage', { error: currentUser.signupLoginStatus !== 200 })}>
                        {isLogin
                            ? getLoginStatusMessage(currentUser.signupLoginStatus)
                            : getSignupStatusMessage(currentUser.signupLoginStatus)}
                    </p>
                ) : null}
                {!isLogin ? <p className="slMessage reqs">{t('login.requirements')}</p> : null}
                <div className="legaleese">
                    {isLogin ? (
                        <span>
                            <Trans i18nKey="login.login legal">
                                By clicking &quot;Log in&quot; I agree to Sugarcube&apos;s{' '}
                                <a href="/termsofuse">Terms of Service</a>, <a href="/privacypolicy">Privacy Policy</a>{' '}
                                and the default Notification Settings.
                            </Trans>
                        </span>
                    ) : (
                        <span>
                            <Trans i18nKey="login.signup legal">
                                By clicking &quot;Create Account&quot; I agree to Sugarcube&apos;s{' '}
                                <a href="/termsofuse">Terms of Service</a>, <a href="/privacypolicy">Privacy Policy</a>{' '}
                                and the default Notification Settings.
                            </Trans>
                        </span>
                    )}
                </div>
                <div className="buttonContainer">
                    <ActionButton onClick={this.submit} disabled={!this.validateForm()}>
                        {isLogin ? t('login.log in') : t('login.create account')}
                    </ActionButton>
                </div>
            </form>
        )
    }
}

SignupForm.defaultProps = {
    isLogin: false,
}
SignupForm.propTypes = {
    isLogin: bool,
    signupWithEmail: func.isRequired,
    loginWithEmail: func.isRequired,
    currentUser: userType.isRequired,
    t: func.isRequired,
}

export default withTranslation()(SignupForm)
